import { IoCallOutline, IoLocationSharp, IoTime, IoMailOutline } from "react-icons/io5";

const contactInfo = [
  {
    icon: <IoCallOutline size={48} style={{ color: "var(--primary)" }} />,
    title: "Phone",
    details: "Call us for immediate assistance",
    phone: "+91 88850 66991",
  },
  {
    icon: <IoMailOutline size={48} style={{ color: "var(--primary)" }} />,
    title: "Email",
    details: "Send us an email anytime",
    phone: "rajesh@zenviafood.com",
  },
  {
    icon: <IoLocationSharp size={48} style={{ color: "var(--primary)" }} />,
    title: "Office Address",
    details: "Zenvia Foods Private Limited",
    phone: "Plot 121, 1st floor, Road 3, Kakateeyahills, Madhapur, Hyderabad, 500081, TG",
  },
  {
    icon: <IoLocationSharp size={48} style={{ color: "var(--primary)" }} />,
    title: "Plant Address",
    details: "Zenvia Foods Private Limited",
    phone: "284/11/8C, Bhavathi Amman Kovil Street, Surulipatti, Cumbum, Tamil Nadu - 625516",
  },
  {
    icon: <IoTime size={48} style={{ color: "var(--primary)" }} />,
    title: "Business Hours",
    details: "We're here to help you",
    phone: "Mon-Sat: 9:00 AM - 6:00 PM",
  },
];

const subjects = [
  "Select a subject",
  "Product Inquiry",
  "Bulk Order Request",
  "Quality Information",
  "Partnership Opportunity",
  "Technical Support",
  "General Information",
  "Complaint/Feedback",
];

export { contactInfo, subjects };
